module.exports = __webpack_public_path__ + "280e23f82b94f2dda96da6bf2ed33923.png";